import "./TGases.css";
import PerfilVen01 from "./components/perfilVen01";
import { Grid } from "@scuf/common";
import AguaEnfriamiento from "./components/aguaEnfriamiento";
import PerfilHESP from "./components/perfilHESP";
import PerfilTemperaturaTDG from "./components/perfilTemperaturaTDG";
import DeltasPresionTostador from "./components/deltasPresionTostador";
import SalidaFreeboard from "./components/salidaFreeboard";
import PerfilGasesSalidaTE from "./components/perfilGasesSalidaTE";
import PerfilGasesSalidaHESP from "./components/perfilGasesSalidaHESP";
import PerfilGasesSalidaCPC from "./components/perfilGasesSalidaCPC";
import PerfilGasesSalidaCiclones from "./components/perfilGasesSalidaCiclones";
import PerfilCorrienteHESP from "./components/perfilCorrienteHESP";
import PerfilCorrienteEDP9 from "./components/perfilCorrienteEDP9";
import PerfilCorrienteEDP13 from "./components/perfilCorrienteEDP13";
import PerfilChispasHESP from "./components/perfilChispasHESP";
import CalcinaProduciaTeorica from "./components/calcinaProducidaTeorica";

export default function TGases() {
  return (
    <>
    <Grid>
      <Grid.Row className="tostador-row">
        <Grid.Column className="tostador-column" width={6} mWidth={12}>
          {" "}
          <PerfilHESP/>
        </Grid.Column>
        <Grid.Column className="tostador-column" width={6} mWidth={12}>
          {" "}
          <PerfilCorrienteHESP/>
        </Grid.Column>
        <Grid.Column className="tostador-column" width={6} mWidth={12}>
          {" "}
          <PerfilChispasHESP/>
        </Grid.Column>
        <Grid.Column className="tostador-column" width={6} mWidth={12}>
          {" "}
          <PerfilVen01 />
        </Grid.Column>
        <Grid.Column className="tostador-column" width={6} mWidth={12}>
          {" "}
          <AguaEnfriamiento/>
        </Grid.Column>
        <Grid.Column className="tostador-column" width={6} mWidth={12}>
          {" "}
          <PerfilTemperaturaTDG/>
        </Grid.Column>
        <Grid.Column className="tostador-column" width={6} mWidth={12}>
          {" "}
          <DeltasPresionTostador/>
        </Grid.Column>
        <Grid.Column className="tostador-column" width={6} mWidth={12}>
          {" "}
          <SalidaFreeboard/>
        </Grid.Column>
        <Grid.Column className="tostador-column" width={6} mWidth={12}>
          {" "}
          <PerfilGasesSalidaCiclones/>
        </Grid.Column>
        <Grid.Column className="tostador-column" width={6} mWidth={12}>
          {" "}
          <PerfilGasesSalidaCPC/>
        </Grid.Column>
        <Grid.Column className="tostador-column" width={6} mWidth={12}>
          {" "}
          <PerfilGasesSalidaTE/>
        </Grid.Column>
        <Grid.Column className="tostador-column" width={6} mWidth={12}>
          {" "}
          <PerfilGasesSalidaHESP/>
        </Grid.Column>
        <Grid.Column className="tostador-column" width={6} mWidth={12}>
          {" "}
          <PerfilCorrienteEDP13/>
        </Grid.Column>
        <Grid.Column className="tostador-column" width={6} mWidth={12}>
          {" "}
          <CalcinaProduciaTeorica/>
        </Grid.Column>
      </Grid.Row>
    </Grid>
  </>
  );
}
